module.exports = __webpack_public_path__ + "img/bar-chart.58bdb944.svg";